module.exports = __webpack_public_path__ + "img/首页二维码1.f36f3f71.png";